import Store from '../Store';
import * as React from 'react';
import { observer } from 'mobx-react';
import { AlreadyTranslated } from '@execonline-inc/translations';

export interface Props {
  store: Store;
}

const Right: React.FC<Props> = ({ store }) => {
  return (
    <div
      className="ml-6 max-h-[54vh] basis-7/12 overflow-auto lg:basis-10/12"
      data-intercom-target="competency-details"
    >
      {store.resource.payload.competencies.map((comp) => (
        <div
          className="mb-6 border-b-1 border-solid last:mb-0 last:border-b-0"
          id={`${comp.payload.id}`}
          key={comp.payload.id}
        >
          <h3 className="text-xl font-medium">
            {comp.payload.name
              .map((name) => <AlreadyTranslated content={name} />)
              .getOrElse(() => (
                <></>
              ))}
          </h3>
          <p className="w-4/5 py-6">
            {comp.payload.description
              .map((desc) => <AlreadyTranslated content={desc} />)
              .getOrElse(() => (
                <></>
              ))}
          </p>
        </div>
      ))}
    </div>
  );
};

export default observer(Right);
